import React from "react";

// Simple determinate meter (0-100). Used for subscription return-credit usage
// today; generic enough to reuse anywhere a "N of M used" bar is needed.
const ProgressBar = ({ value = 0, max = 100, tone = "accent", className = "" }) => {
  const pct = max > 0 ? Math.max(0, Math.min(100, (value / max) * 100)) : 0;
  const fillVar = tone === "warn" ? "var(--amber)" : tone === "danger" ? "var(--danger)" : "var(--accent)";
  return (
    <div
      className={`w-full h-2 rounded-full bg-[var(--panel-2)] overflow-hidden ${className}`}
      role="progressbar"
      aria-valuenow={value}
      aria-valuemin={0}
      aria-valuemax={max}
    >
      <div className="h-full rounded-full transition-all duration-300" style={{ width: `${pct}%`, background: fillVar }} />
    </div>
  );
};

export default ProgressBar;
